import {FC, memo} from 'react'

const HeartIcon: FC<{filled?: boolean}> = ({filled}) => (
    <svg
        className='moduleNews_likeIconSvg'
        viewBox='0 0 24 24'
        width='20'
        height='20'
        aria-hidden='true'
        focusable='false'
    >
        {filled ? (
            <path
                fill='currentColor'
                d='M12 21s-1-.45-2.05-1.21C6.4 17.49 2 14.28 2 9.9 2 7.19 4.15 5 6.8 5c1.57 0 3.04.76 4 1.94C11.16 5.76 12.63 5 14.2 5 16.85 5 19 7.19 19 9.9c0 4.38-4.4 7.59-7.95 9.89C13 20.55 12 21 12 21z'
            />
        ) : (
            <path
                fill='none'
                stroke='currentColor'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
                d='M12.1 20.3C7.14 16.9 3 13.9 3 9.6 3 7 5 5 7.5 5c1.7 0 3.2.9 4 2.3C12.3 5.9 13.8 5 15.5 5 18 5 20 7 20 9.6c0 4.3-4.14 7.3-9.1 10.7z'
            />
        )}
    </svg>
)

export const LikeBadge: FC<{count?: number; liked?: boolean}> = memo(({count, liked}) => (
    <span className={`moduleNews_likeBadge${liked ? ' active' : ''}`}>
        <span className='moduleNews_likeIcon' role='img' aria-label={liked ? 'liked' : 'not liked'}>
            <HeartIcon filled={liked} />
        </span>
        {typeof count === 'number' && count > 0 ? (
            <span className='moduleNews_likeCount'>{count}</span>
        ) : null}
    </span>
))
